<template>
	<v-row>
		<v-col cols="12 py-0 pt-2 px-8">
			<h3>Thông tin SKU</h3>
		</v-col>
		<v-col cols="12" class="py-0 pt-4">
			<v-row>
				<v-col cols="6" class="py-0 px-8">
					<div class="d-flex">
						<v-btn class="btn-info" small @click="showCreateForm">
							+ Thêm SKU
						</v-btn>

						<v-btn
							class="btn-save mx-0"
							small
							@click="handleEditAll"
						>
							Chỉnh sửa hàng loạt
						</v-btn>
						<v-btn
							class="btn-save-all mx-3"
							small
							v-if="checkShowSaveAll()"
							@click="handleSaveAll"
							>
							Lưu hàng loạt
						</v-btn>
					</div>
				</v-col>
				<v-col cols="6" class="py-0 px-8 justify-end d-flex">
					<v-row>
						<v-col offset="6" cols="6" class="py-0">
							<v-text-field
								class="text-search"
								outlined
								dense
								placeholder="Nhập tên SKU"
								@keyup="searchSkuOffline"
								v-model="txtSkuName"
							>
								<v-icon
									class="icon-search"
									slot="prepend"
									color="#adadad"
								>
									mdi-magnify
								</v-icon>
							</v-text-field>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-col>
		<v-col class="py-0 px-8 pb-3 table-product" cols="12">
			<v-simple-table class="table-layout table-custom table-sku">
				<thead>
					<tr>
						<th class="col-code">Mã SKU</th>
						<th class="col-name">Tên SKU*</th>
						<th class="col-price">Giá</th>
						<th class="col-status">Đơn vị*</th>
						<th class="col-status">Trạng thái*</th>
						<th class="col-transaction">Giao dịch*</th>
						<th class="col-action text-center">Thao tác</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="!skuItems.length">
						<td colspan="13">Không có dữ liệu</td>
					</tr>
					<template v-if="skuItems.length">
						<validation-observer
							ref="validator"
							v-for="(item, index) in skuItems"
							tag="tr"
							:key="index"
							@dblclick="handleEditRow(item)"
						>
							<td :class="[item.isEdit ? 'edit-data' : '']">
								{{ item.code || "__" }}
							</td>
							<td :class="[item.isEdit ? 'mt-6' : '']">
								<template v-if="item.isEdit">
									<validation-provider
										v-slot="{ errors }"
										:rules="{ required: true }"
										name="Tên SKU"
										:vid="`name + ${index}`"
									>
										<v-text-field
											class="text-field"
											:error-messages="errors"
											outlined
											dense
											maxLength="100"
											placeholder="Nhập tên SKU"
											v-model="item.name"
										>
										</v-text-field>
									</validation-provider>
								</template>
								<span v-else>{{ item.name }}</span>
							</td>
							<td>
								<template v-if="item.isEdit">
									<validation-provider
										v-slot="{ errors }"
										:rules="{ required: true, max: 10 }"
										name="Giá"
										:vid="`orgPrice + ${index}`"
									>
										<v-text-field
											class="text-field text-field-number"
											:error-messages="errors"
											outlined
											dense
											placeholder="Nhập giá"
											type="number"
											min="0"
											@input="
												item.orgPrice =
													item.orgPrice.replace(
														/[^0-9\.]/g,
														''
													)
											"
											v-model="item.orgPrice"
										>
										</v-text-field>
									</validation-provider>
								</template>
								<span v-else>{{
									item.orgPrice
										? formatPrice(item.orgPrice) + " đ"
										: "0 đ"
								}}</span>
							</td>
							<td>
								<template v-if="item.isEdit">
									<validation-provider
										v-slot="{ errors }"
										:rules="{ required: true }"
										name="Đơn vị"
										:vid="`unitType + ${index}`"
									>
										<v-select
											class="text-field"
											:error-messages="errors"
											:clearable="true"
											:items="skuArtifactUnitType"
											item-value="id"
											item-text="name"
											:aLight="'right'"
											placeholder="Chọn"
											attach
											outlined
											dense
											v-model="item.unitType"
											:menu-props="{
												bottom: true,
												offsetY: true,
												maxHeight: '150',
											}"
										></v-select>
									</validation-provider>
								</template>
								<span v-else>
									{{ skuArtifactUnitTypeObj[item.unitType] }}
								</span>
							</td>
							<td>
								<template v-if="item.isEdit">
									<validation-provider
										v-slot="{ errors }"
										:rules="{ required: true }"
										name="Trạng thái"
										:vid="`status + ${index}`"
									>
										<v-select
											class="text-field"
											:error-messages="errors"
											:clearable="true"
											:items="skuStatus"
											item-value="id"
											item-text="name"
											:aLight="'right'"
											placeholder="Chọn"
											attach
											outlined
											dense
											v-model="item.status"
											:menu-props="{
												bottom: true,
												offsetY: true,
												maxHeight: '150',
											}"
										></v-select>
									</validation-provider>
								</template>
								<span v-else>
									{{ skuStatusObj[item.status] }}
								</span>
							</td>
							<td>
								<template v-if="item.isEdit">
									<validation-provider
										v-slot="{ errors }"
										:rules="{ required: true }"
										name="Giao dịch"
										:vid="`transactionStatus + ${index}`"
									>
										<v-select
											class="text-field"
											:error-messages="errors"
											:clearable="true"
											:items="skuTransaction"
											item-value="id"
											item-text="name"
											:aLight="'right'"
											placeholder="Chọn"
											attach
											outlined
											dense
											v-model="item.transactionStatus"
											:menu-props="{
												bottom: true,
												offsetY: true,
												maxHeight: '150',
											}"
										></v-select>
									</validation-provider>
								</template>
								<span v-else>
									{{
										skuTransactionObj[
											item.transactionStatus
										]
									}}
								</span>
							</td>
							<td
								:class="[
									item.isEdit ? 'edit-data' : '',
									'text-center',
								]"
							>
								<div class="d-flex align-center justify-center">
									<div
										v-show="
											item.isEdit &&
											!item.id &&
											!productId
										"
									>
										<v-tooltip bottom>
											<template v-slot:activator="{ on }">
												<v-icon
													@click="
														handleSubmitData(
															item,
															index
														)
													"
													class="cursor-pointer"
													color="#002E86"
													v-on="on"
												>
													mdi-content-save
												</v-icon>
											</template>
											<span>Save draft</span>
										</v-tooltip>
									</div>
									<div v-show="item.isEdit && productId">
										<v-tooltip bottom>
											<template v-slot:activator="{ on }">
												<v-icon
													@click="
														handleSubmitData(
															item,
															index
														)
													"
													class="cursor-pointer"
													color="#329D20"
													v-on="on"
												>
													mdi-check-circle
												</v-icon>
											</template>
											<span>
												{{
													item.id
														? "Update"
														: "Create"
												}}</span
											>
										</v-tooltip>
									</div>
									<div v-show="productId">
										<v-tooltip v-if="productId" bottom>
											<template v-slot:activator="{ on }">
												<v-icon
													v-on="on"
													@click="cloneSKU(item)"
													class="ml-3 cursor-pointer"
													color="#4048FF"
												>
													mdi-plus-circle-outline
												</v-icon>
											</template>
											<span>Clone SKU</span>
										</v-tooltip>
									</div>
									<div v-show="!item.id">
										<v-tooltip bottom>
											<template v-slot:activator="{ on }">
												<v-icon
													v-on="on"
													class="ml-3 cursor-pointer"
													color="#959595"
													@click="
														deleteSku(item, index)
													"
												>
													mdi-delete
												</v-icon>
											</template>
											<span>Xóa SKU</span>
										</v-tooltip>
									</div>
									<v-tooltip bottom v-if="item.id">
										<template v-slot:activator="{ on }">
											<a :href="`${detailSkuLink(item, index)}`" rel="noopener noreferrer" @click.prevent>
												<v-icon
													v-on="on"
													class="ml-3 cursor-pointer"
													color="#959595"
													@click="detailSku(item, index)"
												>
													mdi-sale
												</v-icon>
											</a>
										</template>
										<span>Chính sách</span>
									</v-tooltip>
								</div>
							</td>
						</validation-observer>
					</template>
					<tr v-if="skuItems.length < 4" class="tr-no-data">
						<td colspan="13"></td>
					</tr>
				</tbody>
			</v-simple-table>
		</v-col>
	</v-row>
</template>

<script>
import RepositoryFactory from "@/repositories/RepositoryFactory";
const OrderRepository = RepositoryFactory.get("order");

import SkuArtifact from "../../models/SkuArtifact";
import { formatDate } from "@/helpers/utils";
import Login from "@/pages/Login.vue";

export default {
	name: "artifact-sku-list",
	components: {},
	props: {
		skuItems: {
			type: Array,
			default: () => [],
		},
		productAttributes: {
			type: Object,
			default: () => {},
		},
		productId: {
			type: Number,
			default: () => null,
		},
		curriculumsObj: {
			type: Object,
			default: () => {},
		},
		curriculums: {
			type: Array,
			default: () => {},
		},
	},
	data() {
		return {
			tab: 0,
			isShowSku: false,
			newSku: new SkuArtifact({}),
			grades: [],
			skuActivation: [],
			durationType: [],
			skuStatus: [],
			skuTransaction: [],
			learningPaths: [],
			skuStatusObj: {},
			skuTransactionObj: {},
			learningPathsObj: {},
			txtSkuName: null,
			listProduct: [],
			lmsCodes: [],
			isEditAll: false,
			skuArtifactUnitType: [],
			skuArtifactUnitTypeObj: {},
		};
	},
	computed: {},
	async created() {
		this.skuArtifactUnitType = this.productAttributes.skuArtifactUnitType;
		this.productAttributes.skuArtifactUnitType.forEach((item) => {
			this.skuArtifactUnitTypeObj[item.id] = item.name;
		});

		this.skuStatus = this.productAttributes.skuStatus;
		this.productAttributes.skuStatus.forEach((item) => {
			this.skuStatusObj[item.id || item.code] = item.name;
		});

		this.skuTransaction = this.productAttributes.skuTransaction;
		this.productAttributes.skuTransaction.forEach((item) => {
			this.skuTransactionObj[item.id || item.code] = item.name;
		});

		// this.getLmsCodes();
	},
	methods: {
		handleEditRow(item) {
			this.$emit("onEditRow", item);
		},
		async handleSaveAll() {
			await this.skuItems.forEach((item, index) => {
				if (item.isEdit) {
					this.handleSubmitData(item, index)
				}
			})
      	},
		async handleSubmitData(item, index) {
			const valid = await this.$refs.validator[index].validate();
			if (!valid) {
				return;
			} else {
				if (this.productId) {
					const data = this.makeData(item);
					delete data.data.skuItem.id;
					if (item.id) {
						this.$emit("onUpdateRow", item, {
							skuId: item.id,
							...data,
						});
					} else {
						this.$emit("onCreateRow", data);
					}
				} else {
					item.isEdit = false;
				}
			}
		},
		makeData(item) {
			const skuItem = new SkuArtifact(item);
			return {
				data: {
					skuItem: {
						...skuItem,
						name: item.name.trim(),
						code: item.code,
					},
				},
			};
		},
		cloneSKU(item) {
			this.$emit("onCloneSKU", item);
		},
		handleEditAll() {
			this.isEditAll = !this.isEditAll;
			if (this.isEditAll) {
				this.skuItems.forEach((item) => (item.isEdit = true));
			} else {
				this.skuItems.forEach((item) => (item.isEdit = false));
			}
		},
		searchSkuOffline: _.debounce(function (item, index, type = null) {
			this.$emit("searchSkuOffline", this.txtSkuName.trim());
		}, 500),
		showCreateForm() {
			this.$emit("onCreateSKU");
		},
		deleteSku(item, index) {
			if (!item.id) {
				this.$swal
					.fire({
						title: "Bạn muốn đóng form? Tất cả thông tin sẽ bị mất!",
						icon: "warning",
						showCancelButton: true,
						cancelButtonText: "Hủy",
						confirmButtonColor: "#3085d6",
						cancelButtonColor: "#d33",
						confirmButtonText: "Đồng ý",
					})
					.then(async (result) => {
						if (result?.value) {
							this.skuItems.splice(index, 1);
						}
					});
			}
		},
		detailSku(item) {
			this.$router.push({
				path: `/products/${this.productId}/sku/${item.id}`,
				query: {
					sku_type: "tutor",
				},
			});
		},
		detailSkuLink(item) {
			return `/products/${this.productId}/sku/${item.id}?sku_type=tutor`;
		},
		checkShowSaveAll() {
			const data = _.cloneDeep(this.skuItems)
			if (data.filter(item => item.isEdit).length > 1) {
				return true
			}
			return false
     	 },
		// async getLmsCodes() {
		// 	const res = await OrderRepository.getListLmsCodes();
		// 	if (res && res.data) {
		// 		this.lmsCodes = res.data;
		// 	}
		// },
	},
	watch: {},
};
</script>
<style scoped lang="scss">
.btn-save {
	background: #8465ff !important;
	color: #fff;
}
.btn-cancel {
	background: #787878 !important;
	color: #fff;
}

.btn-info {
	background: #6587ff !important;
	color: #fff;
}

.icon-search {
	left: 40px;
	position: relative;
}
.table-custom {
	th {
		background: #e7e8ff;
		border-left: 1px solid #fff;
	}
}

.col-code {
	max-width: 150px;
	min-width: 150px;
}
.col-name {
	max-width: 300px;
	min-width: 300px;
}

.col-name-card {
	max-width: 300px;
	min-width: 300px;
}

.col-price {
	max-width: 150px;
	min-width: 150px;
}
.col-subject {
	max-width: 250px;
	min-width: 250px;
}
.col-curriculum {
	max-width: 250px;
	min-width: 250px;
}
.col-program-group {
	max-width: 250px;
	min-width: 250px;
}
.col-level {
	max-width: 180px;
	min-width: 180px;
}
.col-class-type {
	max-width: 180px;
	min-width: 180px;
}
.col-teacher-type {
	max-width: 180px;
	min-width: 180px;
}
.col-num-lesson {
	max-width: 150px;
	min-width: 150px;
}
.col-status {
	max-width: 240px;
	min-width: 240px;
}
.col-transaction {
	max-width: 180px;
	min-width: 180px;
}
.col-action {
	max-width: 150px;
	min-width: 150px;
}
</style>

<style lang="scss">
.text-field fieldset {
	background: #fff !important;
}
.text-search {
	.v-input__slot {
		min-height: 20px !important;
		padding-left: 35px !important;
	}
}
.edit-data {
	vertical-align: top;
	padding-top: 24px !important;
}
</style>
